<template>
    <div class="regions-list relative w-full">
        <div class="flex w-full" :class="isOfertas ? 'flex-col' : 'flex-row space-x-4'">
            <div :class="isOfertas ? 'w-full' : 'w-1/3'">
                <select-input name="distrito" v-model="distrito" v-on:change="changeDistrito" label="Distrito" id="dist">
                    <option value="" disabled>Distrito</option>
                    <option v-for="distrito in filterDistritos" :value="distrito.name" :data-dist="distrito.code">
                        {{ distrito.name }}
                    </option>
                </select-input>
            </div>
            <div :class="isOfertas ? 'w-full' : 'w-1/3'">
                <select-input name="concelho" v-model="concelho" v-on:change="changeConcelho" label="Concelho" ref="conc">
                    <option value="" disabled>Concelho</option>
                    <option v-for="concelho in filterConcelhos" :value="concelho.name" :data-conc="concelho.code">
                        {{ concelho.name }}
                    </option>
                </select-input>
            </div>
            <div :class="isOfertas ? 'w-full' : 'w-1/3'">
                <select-input name="freguesia" v-model="freguesia" v-on:change="changeFreguesia" label="Freguesia" ref="freg">
                    <option value="" disabled>Freguesia</option>
                    <option v-for="freguesia in filterFreguesias" :value="freguesia.name" :data-freg="freguesia.code">
                        {{ freguesia.name }}
                    </option>
                </select-input>
            </div>
        </div>  
    </div>
</template>

<style scoped>

</style>

<script>
import SelectInput from '@/Components/SelectInput'

    export default {
        components: {
            SelectInput
        },
        props: {
            resDistrito: String,
            resConcelho: String,
            resFreguesia: String,
        },
        data() {
            return {
                regioes: [],
                distrito: '',
                concelho: '',
                freguesia: '',
                distritoCode: '',
                concelhoCode: '',
                freguesiaCode: '',
                isOfertas: false
            }
        },
        created() {
            this.fetchDistritos()


            this.distrito = this.resDistrito
            this.concelho = this.resConcelho
            this.freguesia = this.resFreguesia

            if(this.$inertia.page.url == '/ofertas-de-emprego') {
                this.isOfertas = true
            } else {
                this.isOfertas = false
            }
            
        },
        computed: {
            filterDistritos () {
                return this.regioes.filter(({ level }) => level === 1)
            },
            filterConcelhos () {
                const codeCheck = new RegExp(`^${this.distritoCode}\\d{2}$`)
                return this.regioes
                .filter(({ level, code }) =>
                level === 2 && codeCheck.test(code))
            },
            filterFreguesias () {
                const codeCheck = new RegExp(`^${this.concelhoCode}\\d{2}$`)
                return this.regioes
                .filter(({ level, code }) =>
                level === 3 && codeCheck.test(code))
            }
        },
        methods: {
            async fetchDistritos(){
                const res = await fetch('/json/regioes.json')
                const data = await res.json()
                this.regioes = data 

                if(this.resDistrito) {
                    this.filterDistritos.filter((distrito) => {
                        if(distrito.name == this.resDistrito){
                            this.distritoCode = distrito.code
                        }
                    })
                    this.filterConcelhos.filter((concelho) => {
                        if(concelho.name == this.resConcelho){
                            this.concelhoCode = concelho.code
                        }
                    })
                }
            },
            changeDistrito(e){
                if (this.distrito != '') {
                    this.distritoCode = e.target.options[e.target.options.selectedIndex].dataset.dist
                    this.$emit("distrito", e.target.value);
                    this.$emit("distritoCode", this.distritoCode);
                }
            },
            changeConcelho(e){
                if (this.concelho != '') {
                    this.concelhoCode = e.target.options[e.target.options.selectedIndex].dataset.conc
                    this.$emit("concelho", e.target.value);
                    this.$emit("concelhoCode", this.concelhoCode);
                }
            },
            changeFreguesia(e){
                if (this.freguesia != '') {
                    this.freguesiaCode = e.target.options[e.target.options.selectedIndex].dataset.freg
                    this.$emit("freguesia", e.target.value);
                    this.$emit("freguesiaCode", this.freguesiaCode);
                }
            }
        }
    }
</script>